// src/Contexts/AuthContext.js
import { createContext, useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { setWafeqCredentials, hasWafeqAccess } from "../Api/constants";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [hasWafeq, setHasWafeq] = useState(false); // حالة جديدة لتتبع وجود Wafeq
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const userData = localStorage.getItem("user");
    if (token) {
      setIsLoggedIn(true);
      if (userData) {
        const parsedUser = JSON.parse(userData);
        setUser(parsedUser);
        // تعيين بيانات Wafeq من التخزين المحلي
        if (parsedUser.Access) {
          setWafeqCredentials(parsedUser.Access);
          setHasWafeq(hasWafeqAccess());
        }
      }
    }
    setIsLoading(false);
  }, []);

  const login = (userData, token) => {
    if (token) {
      localStorage.setItem("token", token);
    }
    let UpdatedData = userData;
    if (isLoggedIn) {
      UpdatedData = { ...user, ...userData };
    }
    localStorage.setItem("user", JSON.stringify(UpdatedData));
    setUser(UpdatedData);
    setIsLoggedIn(true);
    // تعيين بيانات Wafeq بعد التسجيل
    if (UpdatedData.Access) {
      setWafeqCredentials(UpdatedData.Access);
      setHasWafeq(hasWafeqAccess());
    }
    if (
      window.location.pathname == "/" ||
      window.location.pathname == "/login"
    ) {
      navigate("/dashboard");
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    setIsLoggedIn(false);
    setHasWafeq(false);
    // إعادة تعيين قيم Wafeq
    setWafeqCredentials([]);
   navigate("/");  
  };

  const value = {
    isLoggedIn,
    user,
    login,
    logout,
    isLoading,
    hasWafeq, // إضافة هذه القيمة للسياق
    token: user?.CustomerAccessToken,
  };

  return (
    <AuthContext.Provider value={value}>
      {!isLoading && children}
    </AuthContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useAuth = () => {
  return useContext(AuthContext);
};
